const TAILWIND_CLASS_TOKEN = /^tw-[\w:%./()[\]-]+$/;
const MAX_CLASS_TOKENS = 12;
const MAX_CLASS_STRING_LENGTH = 240;

function readString(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined;
}

export function normalizeTailwindClasses(value: unknown): string | undefined {
  const raw = readString(value)?.trim();
  if (!raw || raw.length > MAX_CLASS_STRING_LENGTH) return undefined;

  const tokens = raw.split(/\s+/).filter(Boolean).slice(0, MAX_CLASS_TOKENS);
  const validTokens = tokens.filter((token) => TAILWIND_CLASS_TOKEN.test(token));

  return validTokens.length ? validTokens.join(' ') : undefined;
}
